import React from "react";
import ReactDOM from "react-dom/client";
import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import * as Sentry from "@sentry/react";

import App from "@/App";
import LanguageSync from "@/LanguageSync";

import store from "@/store";
import reportWebVitals from "@/reportWebVitals";
import {applyGlass, applyTheme} from "@/style/utils";
import {generatePresentationPDF} from "@/utils/generatePresentationPDF";

// Expose presentation generator for quick access
window.generatePresentation = generatePresentationPDF;

Sentry.init({
	dsn: "https://c351d4f55153e1c0c54aac5c6b332053@o4511823738699776.ingest.de.sentry.io/4511823744663632",
	dataCollection: {
		// To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
		// https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
		// userInfo: false,
		// httpBodies: []
	},
	integrations: [Sentry.browserTracingIntegration()],
	// Tracing
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
	// Enable logs to be sent to Sentry
	enableLogs: true,
});

applyTheme();
applyGlass();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<BrowserRouter>
				<LanguageSync />
				<App />
			</BrowserRouter>
		</Provider>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
